import React, { useEffect } from "react";
// import Sidebar from "./SideNav";
import Sidebar from "./SideBar";
// import AskJeeves from "./AskJeeves";
import AskJeevesHome from "./AskJeevesChat";
// import { useApp } from "../context/Appcontext";
import { useApp } from "../../../../context/AppContext";

export default function ChatLayout() {
  const { optedIn, setOptedIn, isLogin, setIsLogin, fetchCallerData } = useApp();

  useEffect(() => {
    fetchCallerData();
  }, []);
  return (
    <div className="flex bg-gray-100 h-[100%] ">
      {/* Sidebar */}

      <div className="z-50">
        {/* {optedIn &&  <Sidebar />} */}
        <Sidebar />
      </div>

      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col bg-gray-100 ">
        <AskJeevesHome />
      </div>

      {/* <ModalForm/> */}
    </div>
  );
}
